import React from "react";
import "./index.scss";
const LoginContainer = ({ children }) => {
    return <div className="login__container">
        {children}
    </div>
}
export default LoginContainer;